import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearSearch, fetchSearchList, activePage } from '../../store/actions/searchActions';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import lang from './lang';


class SearchList extends Component {
    state = { totalItems: 0, currentData: [], pageSize: 5, currentPage: 1 }

    componentDidMount() {
        console.log(this.props.activeSearchPage);

        this.setState({
            totalItems: this.props.search.length,
            currentData: this.props.search.slice(0, this.state.pageSize),
            currentPage: this.props.activeSearchPage
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.search !== prevProps.search) {
            this.setState({
                totalItems: this.props.search.length,
                currentData: this.props.search.slice(0, this.state.pageSize),
                currentPage: this.props.activeSearchPage
            })
        }
    }

    pageHandler = (page) => {
        const startPosition = this.state.pageSize * page - this.state.pageSize;
        const endPosition = this.state.pageSize * page <= this.state.totalItems ? (this.state.pageSize * page) : this.state.totalItems;
        this.setState({
            currentData: this.props.search.slice(startPosition, endPosition),
            currentPage: page
        });
        this.props.activePage(page)
    }

    redirectHandler = (id) => {
        this.props.history.push('/products/' + id);
    }

    render() {
        const { name, design, size, quality, brand } = lang[this.props.user.lang || 'uz'];
        return (
            <div className="container pt-5">
                {/* <h3>Search results for</h3> */}
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{name}</th>
                            <th>{design}</th>
                            <th>{size}</th>
                            <th>{quality}</th>
                            <th>{brand}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.currentData.length !== 0 ?
                                (this.state.currentData.map((item, index) => {
                                    return (
                                        <tr key={item.id} onClick={(id) => this.redirectHandler(item.id)} className="text-capitalize tr-link">
                                            <th>{index + 1}</th>
                                            <td>{item.name}</td>
                                            <td>{item.code}</td>
                                            <td>{item.dimensions}</td>
                                            <td>{item.quality}</td>
                                            <td>{item.brand}</td>
                                        </tr>
                                    )
                                }))
                                :
                                (
                                    <tr>
                                        <td>
                                            <div className="alert alert-info text-center">
                                                <h3>Sorry there is no any items for the search</h3>
                                            </div>
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>

                </table>
                <Pagination
                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                    total={this.props.search.length}
                    pageSize={this.state.pageSize}
                    onChange={(page) => this.pageHandler(page)}
                    hideOnSinglePage={true}
                    current={this.state.currentPage}
                />
            </div>
        )
    }
}


const mapStateToProps = state => {

    return {
        search: state.search.search,
        activeSearchPage: state.search.activeSearchPage,
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearSearch: () => dispatch(clearSearch()),
        fetchSearch: () => dispatch(fetchSearchList()),
        activePage: (num) => dispatch(activePage(num)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchList);